// extracted by mini-css-extract-plugin
module.exports = {"optionsSelectorWrapper":"OptionsSelector_optionsSelectorWrapper__BWQpN"};